export const TransformDecimalFields = (order) => {
    if (order.requestedPrice === null) {
        order.requestedPrice = '';
    } else if (order.requestedPrice === '') {
        order.requestedPrice = null;
    }
    if (order.cryptoAmountExecuted === null) {
        order.cryptoAmountExecuted = '';
    } else if (order.cryptoAmountExecuted === '') {
        order.cryptoAmountExecuted = null;
    }
    if (order.executedPrice === null) {
        order.executedPrice = '';
    } else if (order.executedPrice === '') {
        order.executedPrice = null;
    }
    return order;
}